import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { captureException } from '@sentry/react-router';

import OffersListComponent, { type OffersListIndexProps } from '@cx-modules/offers-list';

import { OffersClickoutGuard } from '~/modules/offers-clickout';

export const OffersList = (props: Omit<OffersListIndexProps, 'i18n' | 'clickoutServiceUrl'>) => {
  const { i18n } = useTranslation();

  const filtersThreshold = ['IT'].includes(props.repub) ? 2 : Infinity;

  const preconfiguredProps = {
    ...props,
    filtersThreshold,
    clickoutServiceUrl: ENV.CLICKOUT_URL,
    i18n,
  };

  return (
    <ErrorBoundary
      fallbackRender={({ error }) => {
        captureException(error);
        return null;
      }}
    >
      <Suspense fallback={null}>
        <div
          data-country-code={props.countryCode}
          data-geo-subdivision-code={props.geoSubdivisionCode}
          data-lang={i18n.language}
          data-repub={props.repub}
          data-subdivision-code={props.subdivisionCode}
        >
          <OffersClickoutGuard componentName="OffersList" values={preconfiguredProps}>
            <OffersListComponent {...preconfiguredProps} />
          </OffersClickoutGuard>
        </div>
      </Suspense>
    </ErrorBoundary>
  );
};
